import { render } from "./IWCPage.vue?vue&type=template&id=f0c20b96"
import script from "./IWCPage.vue?vue&type=script&lang=js"
export * from "./IWCPage.vue?vue&type=script&lang=js"

import "./IWCPage.vue?vue&type=style&index=0&id=f0c20b96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__